import { render } from "./AboutUs.vue?vue&type=template&id=2c0f1698"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"

import "./AboutUs.vue?vue&type=style&index=0&id=2c0f1698&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__